<div class="store-container">
  <!-- Settings Navigation -->
  <app-settings-nav [activeItem]="'integrations'" (navigationChange)="onNavigationChange($event)">
  </app-settings-nav>

  <div class="main-content">
    <!-- Page Header -->
    <div class="page-header">
      <h1 class="page-title">Integrations</h1>
    </div>

    <!-- Content Sections -->
    <div class="content-sections">
      <!-- Advertising Section -->
      <div class="section">
        <div class="section-header">
          <h2 class="section-title">Advertising</h2>
          <p class="section-description">Gain full visibility into your advertising efforts—from ad spend to
            cross-channel ROAS & more.</p>
        </div>

        <div class="cards-row">
          <!-- Meta Ads Card -->
          <div class="integration-card" [class.connected]="isFacebookConnected"
            [class.has-dropdown]="showAdAccountDropdown"
            (click)="(!isFacebookConnected && !showAdAccountDropdown) ? connectFacebook() : null">
            <div class="card-content">
              <div class="service-logo">
                <img src="images/meta.png" alt="Meta" />
              </div>
              <div class="service-name">META</div>

              <!-- Connection Status Indicator -->
              <!--
              <div class="connection-status" *ngIf="isFacebookConnected" (click)="openFacebookAccountSelector($event)">
                <div class="status-dot connected"></div>
                <span class="status-text">View connection details</span>
              </div>
              -->
              <!-- Show custom dropdown if multiple ad accounts -->
              <div *ngIf="showAdAccountDropdown" class="account-selector"
                (click)="toggleDropdown(); $event.stopPropagation()">
                <div class="selector-display">
                  {{ selectedAdAccount ? selectedAdAccount.name : 'SELECT' }}
                  <span class="dropdown-arrow" [class.open]="dropdownOpen">▼</span>
                </div>

                <!-- Dropdown menu -->
                <div *ngIf="dropdownOpen" class="dropdown-menu">
                  <div *ngFor="let account of adAccounts" class="dropdown-item"
                    (click)="selectAdAccount(account); $event.stopPropagation()">
                    <div class="account-name">{{ account.name }}</div>
                    <div class="account-id">{{ account.id }}</div>
                  </div>
                </div>
              </div>

              <!-- Action Button -->
              <button class="action-button" [class.disconnect]="isFacebookConnected" *ngIf="!showAdAccountDropdown"
                (click)="isFacebookConnected ? disconnectFacebook() : connectFacebook(); $event.stopPropagation()">
                {{ isFacebookConnected ? 'Disconnect' : 'Connect' }}
              </button>

              <!-- No disconnect while selecting ad account -->
            </div>
          </div>

          <!-- Google Ads Card (moved into Advertising) -->
          <div class="integration-card" [class.connected]="isGoogleAdsConnected"
            [class.has-dropdown]="showGoogleAdsCustomerDropdown"
            (click)="!showGoogleAdsCustomerDropdown ? connectGoogleAds() : null">
            <div class="card-content">
              <div class="service-logo">
                <img src="images/googleads.png" alt="Google Ads" />
              </div>
              <div class="service-name">GOOGLE ADS</div>

              <!-- Connection Status Indicator -->
              <!--
              <div class="connection-status" *ngIf="isGoogleAdsConnected">
                <div class="status-dot connected"></div>
                <span class="status-text">View connection details</span>
              </div>
              -->

              <!-- Show custom dropdown if service exists but no customer selected -->
              <div *ngIf="showGoogleAdsCustomerDropdown" class="account-selector"
                (click)="toggleGoogleAdsDropdown(); $event.stopPropagation()">
                <div class="selector-display">
                  {{ selectedGoogleAdsCustomer ? selectedGoogleAdsCustomer.descriptiveName : 'SELECT' }}
                  <span class="dropdown-arrow" [class.open]="googleAdsDropdownOpen">▼</span>
                </div>

                <!-- Dropdown menu -->
                <div *ngIf="googleAdsDropdownOpen" class="dropdown-menu">
                  <div *ngFor="let customer of googleAdsCustomers" class="dropdown-item"
                    (click)="selectGoogleAdsCustomer(customer); $event.stopPropagation()">
                    <div class="account-name">{{ customer.descriptiveName }}</div>
                    <div class="account-id">{{ customer.ad_account_id }}</div>
                  </div>
                </div>
              </div>

              <!-- Action Button -->
              <button class="action-button" [class.disconnect]="isGoogleAdsConnected"
                *ngIf="!showGoogleAdsCustomerDropdown"
                (click)="isGoogleAdsConnected ? disconnectGoogleAds() : connectGoogleAds(); $event.stopPropagation()">
                {{ isGoogleAdsConnected ? 'Disconnect' : 'Connect' }}
              </button>

              <!-- Disconnect button for dropdown state -->
              <button class="action-button disconnect" *ngIf="showGoogleAdsCustomerDropdown"
                (click)="disconnectGoogleAds(); $event.stopPropagation()">
                Disconnect
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <div class="section-divider"></div>

      <!-- Destination Section -->
      <div class="section">
        <div class="section-header" style="display: flex;gap: 24px;flex-wrap: wrap;">
          <div style="    width: 428px;">
            <h2 class="section-title">Destination</h2>
            <p class="section-description">Libero elit risus felis venenatis arcud elit facilisis orci eu tellus at
              nulla tellus.</p>
          </div>

          <div style="    width: 428px;">
            <h2 class="section-title">Marketing</h2>
            <p class="section-description">Libero elit risus felis venenatis arcud elit facilisis orci eu tellus at
              nulla tellus.</p>
          </div>

        </div>

        <div class="cards-row">
          <!-- Slack Card -->
          <div class="integration-card" [class.connected]="isSlackConnected" (click)="connectSlack()">
            <div class="card-content">
              <div class="service-logo">
                <img src="images/slack.png" alt="Slack" />
              </div>
              <div class="service-name">SLACK</div>

              <!-- Connection Status Indicator -->
              <!--
              <div class="connection-status" *ngIf="isSlackConnected">
                <div class="status-dot connected"></div>
                <span class="status-text">View connection details</span>
              </div>
              -->

              <!-- Show loading state -->
              <div class="loading-state" *ngIf="slackLoading">
                <span>Checking...</span>
              </div>

              <!-- Action Button -->
              <button class="action-button" [class.disconnect]="isSlackConnected" *ngIf="!slackLoading"
                (click)="isSlackConnected ? disconnectSlack() : connectSlack(); $event.stopPropagation()">
                {{ isSlackConnected ? 'Disconnect' : 'Connect' }}
              </button>
            </div>
          </div>

          <!-- Shopify Card (in Destination section) -->
          <div class="integration-card" [class.connected]="isShopifyConnected">
            <div class="card-content">
              <div class="service-logo">
                <img src="images/shopify.png" alt="Shopify" />
              </div>
              <div class="service-name">SHOPIFY</div>

              <!-- Action Button -->
              <button class="action-button" [class.disconnect]="isShopifyConnected"
                (click)="isShopifyConnected ? disconnectShopify() : connectShopify()">
                {{ isShopifyConnected ? 'Disconnect' : 'Connect' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Marketing Section removed: Google Ads is part of Advertising -->
    </div>
  </div>

  <!-- Legacy Shopify Popup (keep for functionality) -->
  <div class="popup-overlay" [class.show]="showShopifyPopup" (click)="closePopup()">
    <div class="popup-content" (click)="$event.stopPropagation()">
      <div class="popup-header">
        <h3>Connect Shopify Store</h3>
        <button class="close-btn" (click)="closePopup()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="popup-body">
        <div class="api-key-input">
          <label class="api-label">SHOP</label>

          <input type="text" placeholder="your-store.myshopify.com" class="api-input" [(ngModel)]="shopifyShop"
            (input)="onShopifyShopChange()" />
        </div>
        <div class="api-key-input" style="margin-top: 24px;">
          <label class="api-label">API TOKEN</label>
          <input type="text" placeholder="PASTE HERE" class="api-input" [(ngModel)]="shopifyApiToken"
            (input)="onShopifyTokenChange()" />
        </div>
        <div class="popup-actions">
          <button class="action-button disconnect" type="button" (click)="closePopup()">Cancel</button>
          <button class="action-button" type="button" (click)="saveShopifyService()">Connect</button>
        </div>
      </div>
    </div>
  </div>
</div>